module.exports = __webpack_public_path__ + "img/banner_new.6d1077d0.png";